import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=be43d7a6&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be43d7a6')) {
      api.createRecord('be43d7a6', component.options)
    } else {
      api.reload('be43d7a6', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=be43d7a6&", function () {
      api.rerender('be43d7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hfYJKuXGU71W/JS/pricehelp.vue"
export default component.exports